(function(){
    'use strict'

    angular
    .module('app.cantidades')
    .controller('Cantidades', Cantidades);

    Cantidades.$inject = ['$animationsSrv', 'CantidadesService', 'logger', '$location', 'UserInfoService'];

    function Cantidades($animationsSrv, CantidadesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.cantidades = [];
        vm.title = 'Cantidades';

        vm.goToEdit = function(cantidad){
            
            var path = '/editar-cantidad/';

            if(cantidad){
                $location.path(path + cantidad.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = CantidadesService.getAll();

            promise
            .then(function(cantidades){
                vm.cantidades = cantidades;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las cantidades.');
                        break;
                }
            });
        };

        vm.delete = function(cantidad){
            var promise = CantidadesService.remove(cantidad);
            
            promise
            .then(function(response){
                vm.cantidades = vm.cantidades.filter(function(g) {
                    return g.id !== cantidad.id;
                });
                logger.success('Cantidad eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al eliminar la Cantidad');
                        break;
                }
                
            });   
        };

    }
})();